// src/pages/NotFound.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { FaQuestionCircle } from "react-icons/fa";

const NotFound = () => {
  const navigate = useNavigate();

  // Function to handle the "Go Back Home" button
  const handleGoHome = () => {
    navigate("/"); // Navigates to the homepage
  };

  return (
    // Outer container: Light gray background (bg-gray-100)
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      {/* Central Card: White, rounded box, consistent with the 403 page */}
      <div className="bg-white p-10 sm:p-12 rounded-lg shadow-2xl max-w-lg w-full text-center">
        {/* Icon and 404 status */}
        <div className="flex flex-col items-center justify-center">
          <div className="relative flex items-center justify-center mb-6">
            {/* Question Mark Icon - Large, Red */}
            <div className="relative">
              <FaQuestionCircle className="text-red-600 text-[5rem] relative z-10" />
              {/* Red 'shadow' part */}
              <div className="absolute top-[-10px] right-[-10px] w-12 h-12 bg-red-400 rounded-full opacity-50 blur-sm z-0"></div>
            </div>

            {/* 404 Badge */}
            <div className="bg-red-500 text-white px-3 py-1 ml-[-15px] mt-[-30px] rounded-md text-xl font-bold shadow-md relative z-20">
              404
            </div>
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-3xl font-bold text-gray-800 mt-0 mb-4">
          PAGE NOT FOUND
        </h1>

        {/* Description: Updated with your requested simple text */}
        <div className="text-gray-600 space-y-1 text-base leading-relaxed">
          <p>We looked everywhere for this page.</p>
          <p>Are you sure the website URL is correct?</p>
          <p>Get in touch with the site owner.</p>
        </div>

        {/* Button - Single button, styled in Red */}
        <div className="flex justify-center mt-6">
          <button
            onClick={handleGoHome}
            // Button style: Red background, white text
            className="bg-red-600 text-white hover:bg-red-700 transition px-8 py-3 rounded-md text-lg font-semibold shadow-lg"
          >
            Go Back Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
